import { z } from 'zod';

export const schoolReportFormSchema = z.object({
  email: z.email({ error: 'Please enter a valid email address' }),
  notes: z.string().trim().min(1, { error: 'Please tell us what looks off' }),
  pdfUrl: z
    .union([z.literal(''), z.url({ error: 'Please enter a valid URL' })])
    .optional(),
});

export type SchoolReportFormValues = z.infer<typeof schoolReportFormSchema>;
